import { Component, ComponentFactoryResolver, OnInit, Self,OnDestroy } from '@angular/core';
import {ViewChild,ElementRef,ChangeDetectorRef} from '@angular/core';
import * as Feather from 'feather-icons';
import { ServerService } from '../services/server.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { HttpClient } from '@angular/common/http';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
declare var iziToast: any;
import Swal from 'sweetalert2'
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { EditorModule } from '@progress/kendo-angular-editor';

declare var tinymce: any;
declare var $: any;
export interface Collobrator {
  email_name: string;
}
export interface EmailAddress {
  email_to: string;
}
@Component({
  selector: 'app-support-ticket-list-thread',
  templateUrl: './support-ticket-list-thread.component.html',
  styleUrls: ['./support-ticket-list-thread.component.css']
})

export class SupportTicketListThreadComponent implements OnInit, OnDestroy  {
@ViewChild('conversationContainer')
conversationContainer!: ElementRef;
  datalist: any;
  replaymessage: any;
  files: any = [];
  value;
  conversation_show = false;
  filesend: any = [];
  param;
  param1;
  message;
  list;
  con = false;
  ticket;
  acess_token;
  customer_id;

  vigDAte:any;
  vigFromMail:any;
  sendChatMessageData: any;
  show_email_errors = false;
  emailFormControl;
  addSenderThread = [];//Send ID for forward thread
  signature_content;
  signature_title;
  ticketDetails;
  ticketConversation;
  tick_subject;
  ticket_created_by;
  tick_from;
  ticket_status_sel;
  ticket_status_perm;
  markspamshow = false;
  unmarkspamshow = false;
  ticket_delete_status = false;
  ticket_status;
  closed = false;
  first_res_time;
  closed_time;
  closed_by;
  Reopen_closed = false;
  admin_permission;
  first_letter;
  department;
  selectedDepart;
  selectedDepart_perm;
  ticket_agent;
  selectedAgentID;
  showmore_button = false;
  selectedAgentID_perm;
  replyMessageText: string = '';
  tick_time;
  ticket_to;
  ticket_cc;
  own_mail;
  replied_from;
  mainCont;
  ticket_message_id;
  ticket_t;
  dept_list;
  total_offet;
  ticket_to_arr;
  status;
  reply_from_arr;
  ticket_id_orginal;
  agent_options;
  ticket_agent_name;
  ticket_agent_country;
  ticket_agent_priority;
  ticket_agent_requestType;

  ticket_agent_id
  collobrators: Collobrator[] = [];
  EmailToAddress: EmailAddress[] = [];
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  customer_profile;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  replytextmessage: FormGroup;
  ticket_media: any;
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    const input = event.input;
    //     const input = event.input;
    // const value = event.value;
    // Add our fruit


    if (value) {
      this.collobrators.push({ email_name: value });
      event.value = "";
    }

    if (input) {
      input.value = '';
    }

    //  event.chipInput!.clear();
  }

  remove(collobrator: Collobrator): void {
    const index = this.collobrators.indexOf(collobrator);

    if (index >= 0) {
      this.collobrators.splice(index, 1);
    }
  }

  //CC Collabrator End
  addTo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    const input = event.input;

    // Add our fruit
    if (value) {
      this.EmailToAddress.push({ email_to: value });
      console.log(this.EmailToAddress)
    }

    if (input) {
      input.value = '';
    }

    // event.chipInput!.clear();
  }

  removeTo(EmailAddress: EmailAddress): void {
    const index = this.EmailToAddress.indexOf(EmailAddress);

    if (index >= 0) {
      this.EmailToAddress.splice(index, 1);
    }
  }


  ext: RegExpExecArray;
  constructor(private router: Router, private http: HttpClient, private serverService: ServerService, private cdr: ChangeDetectorRef, 
    private route: ActivatedRoute, private _location: Location, private tinymce: EditorModule, private fb: FormBuilder) {
    this.param = this.route.snapshot.queryParamMap.get('id');
  }
  refreshInterval: any;
  ngOnInit() {

    var profiles = localStorage.getItem('profile_image');
    if (profiles != '' && profiles != null && profiles != undefined && profiles != 'undefined' && profiles != 'null') {
      this.customer_profile = "https://erp.cal4care.com/cms_new/api_cms/v1.0/profile_image/" + profiles;
    } else {
      this.customer_profile = '';
    }
    // this.param1 = btoa(this.param);
    this.ticket_id_orginal = atob(this.param);
    this.param1 = atob(this.param);
    this.ticket_t = atob(this.param);
    console.log(this.param1);

    this.acess_token = localStorage.getItem('at');
    this.customer_id = localStorage.getItem('en');
    this.ticket_count();
    this.thred_view();
     // Every 5 sec
    this.refreshInterval = setInterval(() => {
      this.thred_view_conversation();
    }, 5000);
    this.initTiny();
    this.EmailToAddress = [];
    this.collobrators = [];
    this.replytextmessage = new FormGroup({
      'subject': new FormControl(null)
    });
    this.route.queryParams.subscribe(params => {

    const encodedId = params['id'];

    if (encodedId) {
      this.param1 = atob(encodedId);
      console.log( 'Ticket ID:', this.param1 );
      this.thred_view_conversation();

    }

  });

  }

  ngOnDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }
  ngAfterViewInit() {
    Feather.replace();

  }
  scrollToLastMessage(): void {

    setTimeout(() => {
      if (!this.conversationContainer) {
        return;
      }
      const container = this.conversationContainer.nativeElement;
      if (!container) {
        return;
      }
      container.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });

    }, 200);
  }

  getShortName(fullName) {
    return fullName.substring(1, 0).toUpperCase();

  }
  // How many of the most recent conversation entries are visible before
  // the user expands the thread.
  readonly INITIAL_VISIBLE_COUNT = 5;

  // Applies the collapsed/expanded state to ticketConversation and decides
  // whether the "Show More" button should be visible at all.
  applyConversationVisibility() {
    if (!this.ticketConversation) {
      this.showmore_button = false;
      return;
    }

    const total = this.ticketConversation.length;
    this.showmore_button = total > this.INITIAL_VISIBLE_COUNT;

    this.ticketConversation.forEach((entry, index) => {
      entry.isHidden = this.conversation_show
        ? false
        : index < total - this.INITIAL_VISIBLE_COUNT;
    });
  }
  showmore() {
    this.conversation_show = !this.conversation_show;
    this.applyConversationVisibility();
  }
  getFileExtension(filename) {
    var ext = /^.+\.([^.]+)$/.exec(filename);
    this.ext = ext;
    return ext == null ? "" : ext[1];
  }



  replyOldticket() {
    Swal.fire('Please wait')
    Swal.showLoading()
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');
    const forms = new FormData();
    forms.append('name', this.datalist.ticket.user_name);
    forms.append('email', this.datalist.ticket.user_email.address);
    forms.append('ticket_number', this.datalist.ticket.ticket_number);
    forms.append('message', this.replaymessage.replace(/<(?:.|\n)*?>/gm, ' '));
    for (var i = 0; i < this.filesend.length; i++) {
      forms.append('attachment[' + i + ']', this.filesend[i]);
    }
    // forms.append('attachment', this.file);
    forms.append('action_info', 'reply_ticket');
    forms.append('action', 'reply_ticket');
    forms.append('operation', 'ticket');
    forms.append('access_token', access_token);
    forms.append('moduleType', 'ticket');
    forms.append('api_type', 'web');
    console.log(forms);
    var self = this;
    $.ajax({
      url: "https://cmsuat.cal4care.com/api_cms/v1.0/index_new.php",
      type: 'POST',
      data: forms,
      processData: false,  // tell jQuery not to process the data
      contentType: false,
      success: function (data) {

      }
    });

    setTimeout(() => {
      Swal.close();
      iziToast.success({
        message: "Ticket Replied Successfully",
        position: 'topRight'
      });
      this.files = [];
      this.filesend = [];
      this.file = null;
      this.replaymessage = "";
      this.ticket_count()
    }, 3000);

    // console.log(data)

  }
  thred_view() {

    Swal.fire('Please wait');
    Swal.showLoading();

    let datas: any = new Object();
    let datasend: any = new Object();

    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');

    datas.action = "helpdesk_viewticket";
    datas.customer_id = customer_id;
    datas.ticket_id = this.param1;

    datasend.access_token = access_token;
    datasend.operation = "helpDeskCurl";
    datasend.moduleType = "ticket";
    datasend.api_type = "web";
    datasend.element_data = datas;

    this.http.post(
      'https://erp.cal4care.com/cms_new/api_cms/v1.0/index.php',
      datasend
    ).subscribe(
      (response: any) => {

        console.log('View Ticket Response:', response);

        Swal.close();

        if (response.result && response.result.status === true) {
          this.ticketDetails = response.result.data;
            // Basic ticket details
          this.tick_subject = this.ticketDetails.subject;
          this.ticket_status = this.ticketDetails.status;
          this.tick_from = this.ticketDetails.requesterEmail;
          this.ticket_id_orginal = this.ticketDetails.number;

          // Agent
          this.ticket_agent_name = this.ticketDetails.assigneeName || '';
          // Metadata details
          this.ticket_agent_country = this.ticketDetails.metadata?.country || '';
          this.ticket_agent_priority = this.ticketDetails.priority || '';
          this.ticket_agent_requestType = this.ticketDetails.metadata?.requestType || '';

            if (this.ticket_status === 'RESOLVED') {
                this.closed = true;
                this.Reopen_closed = false;
              } else {
                this.closed = false;
                if (response?.resolvedAt) {
                  this.Reopen_closed = true;
                } else {
                  this.Reopen_closed = false;
                }

              }
          this.thred_view_conversation();
        } else {
          this.ticketDetails = null;
          this.ticket_agent_name = '';
          this.ticket_agent_country = '';
          this.ticket_agent_priority = '';
          this.ticket_agent_requestType = '';
        }

      },
      (error) => {
        Swal.close();
        console.error('API Error:', error);
      }
    );
  }
  thred_view_conversation1() {

    // Swal.fire('Please wait');
    // Swal.showLoading();

    const access_token = localStorage.getItem('at');
    const customer_id = localStorage.getItem('en');

    const datas = {
      action: 'helpdesk_getconverstionticket',
      customer_id: customer_id,
      ticket_id: this.param1
    };

    const datasend = {
      access_token: access_token,
      operation: 'helpDeskCurl',
      moduleType: 'ticket',
      api_type: 'web',
      element_data: datas
    };

    this.http.post(
      'https://erp.cal4care.com/cms_new/api_cms/v1.0/index.php',
      datasend
    ).subscribe({
      next: (response: any) => {

        console.log('View Conversation Response:', response);

        Swal.close();

        if (response?.result?.status === true) {

          // IMPORTANT: comments is inside data
          const comments = response.result.data?.comments || [];

          this.ticketConversation = comments
            .slice()
            .reverse()
            .map((item: any) => {

              let repliesd_by = 'System';

              if (item.authorType === 'customer') {
                repliesd_by = 'Customer';
              }
              else if (item.authorType === 'staff') {
                repliesd_by = 'Agent';
              }
              else if (item.authorType === 'system') {
                repliesd_by = 'System';
              }
              else if (item.authorType === 'api') {
                repliesd_by = 'System';
              }

              return {

                ticket_message_id: item.id,

                replied_from:
                  item.authorEmail ||
                  item.authorName ||
                  'System',

                agent_name:
                  item.authorName ||
                  item.authorEmail ||
                  'System',

                rep_name: item.authorName,

                ticket_message: item.body || '',

                only_message: item.body || '',

                repliesd_by: repliesd_by,

                ticket_media: item.attachments || [],

                ticket_notes: null,

                ticket_forward_by: null,

                ticket_only_signature: '',

                profile_image: null,

                own_img: null,

                created_dt: this.formatConversationDate(item.createdAt),

                authorType: item.authorType,

                authorName: item.authorName,

                authorEmail: item.authorEmail,

                status_message: item.body || '',

                notifyCustomer: item.notifyCustomer,

                emailStatus: item.emailStatus
              };

            });

          console.log(
            'Mapped Conversation:',
            this.ticketConversation
          );

          // Reset to collapsed view and compute which entries are hidden.
          this.conversation_show = false;
          this.applyConversationVisibility();

        } else {

          this.ticketConversation = [];
          this.showmore_button = false;

          console.warn(
            'No conversation found',
            response
          );
        }
      },

      error: (error) => {

        Swal.close();

        this.ticketConversation = [];
        this.showmore_button = false;

        console.error('API Error:', error);
      }
    });
  }
thred_view_conversation() {

  const access_token = localStorage.getItem('at');
  const customer_id = localStorage.getItem('en');

  const datas = {
    action: 'helpdesk_getconverstionticket',
    customer_id: customer_id,
    ticket_id: this.param1
  };

  const datasend = {
    access_token: access_token,
    operation: 'helpDeskCurl',
    moduleType: 'ticket',
    api_type: 'web',
    element_data: datas
  };

  this.http.post(
    'https://erp.cal4care.com/cms_new/api_cms/v1.0/index.php',
    datasend
  ).subscribe({
    next: (response: any) => {

      console.log('Conversation API called');

      if (response?.result?.status === true) {

        const comments = response?.result?.data?.comments || [];

        const newConversation = comments
          .slice()
          .reverse()
          .map((item: any) => {

            let repliesd_by = 'System';

            if (item.authorType === 'customer') {
              repliesd_by = 'Customer';
            }
            else if (item.authorType === 'staff') {
              repliesd_by = 'Agent';
            }
            else if (
              item.authorType === 'system' ||
              item.authorType === 'api'
            ) {
              repliesd_by = 'System';
            }
            
            
              // Convert attachment objects to URL strings
            const ticket_media = (item.attachments || [])
              .map((attachment: any) => attachment.url)
              .filter((url: string) => !!url);
            return {
              ticket_message_id: item.id,
              replied_from: item.authorEmail || item.authorName || 'Customer',
              agent_name:   item.authorEmail || item.authorName  || 'Agent',
              rep_name: item.authorName,
              ticket_message: item.body || '',
              only_message: item.body || '',
              repliesd_by: repliesd_by,
              ticket_media: ticket_media,
              ticket_notes: null,
              ticket_forward_by: null,
              ticket_only_signature: '',
              profile_image: null,
              own_img: null,
              created_dt: this.formatConversationDate(item.createdAt),
              authorType: item.authorType,
              authorName: item.authorName,
              authorEmail: item.authorEmail,
              status_message: item.body || '',
              notifyCustomer: item.notifyCustomer,
              emailStatus: item.emailStatus
            };
          });
        const oldConversation = this.ticketConversation || [];
        const oldIds = oldConversation
          .map((x: any) => x.ticket_message_id)
          .join(',');

        const newIds = newConversation
          .map((x: any) => x.ticket_message_id)
          .join(',');

        if (oldIds !== newIds) {
          console.log('New message found - updating UI');
          this.ticketConversation = newConversation;
          this.applyConversationVisibility();
          this.cdr.detectChanges();
          this.scrollToLastMessage();
        } else {

          console.log('No new message - UI not updated');

        }

      } else {

        console.warn('No conversation found');

      }
    },

    error: (error) => {
      console.error('Conversation API Error:', error);
    }
  });
}
trackByMessageId(index: number, item: any) {
  return item.ticket_message_id;
}

  formatConversationDate(date: string): string {

    if (!date) {
      return '';
    }

    const d = new Date(date);

    return d.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }



  ticket_count() {
    Swal.fire('Please wait')
    Swal.showLoading()
    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');
    let tck_id: any = atob(localStorage.getItem('tck'));


    datas.action = "getTicketInfo";
    // datas.customer_id = customer_id;

    datas.ticket_id = tck_id;

    datasend.access_token = access_token;
    datasend.operation = "ticket";
    datasend.moduleType = "ticket";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      console.log(response)
      if (response && response.result.status == true) {
        Swal.close();


        if (response.result.data != null) {
          this.datalist = response.result.data;

          for (var i = 0; i < this.datalist.ticket.thread_entries.length; i++) {
            // if(i <= 4){
            if (i != null) {
              this.datalist.ticket.thread_entries[i].show = false;
              console.log(this.datalist.ticket.thread_entries[i].show);
            } else {
              this.datalist.ticket.thread_entries[i].show = true;
            }
          }

          console.log(this.datalist.ticket.thread_entries)
        } else {
          this.datalist = "";
        }

        // this.counts = response.counts

      }
      else {
        Swal.close();
        // this.counts={}

      }

    },
      (error) => {
        console.log(error);
      });

  }
  // filed: File;
  //  uploadFile(event:any) {
  //    this.filed = event.target.files[0];
  //    // console.log(event.target.files[0])
  //    for (let index = 0; index < event.length; index++) {
  //      const element = event[index];
  //      this.files.push(element.names)
  //    }  
  //  }
  localUrl;
  file: File;
  uploadFiless(event) {
    console.log(event[0])
    this.file = event[0];
    if (event[0] != undefined) {
      this.filesend.push(event[0])

    }

    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.files.push(element.name);
    }
    console.log(this.filesend)

  }



  uploadFile(event: any) {
    this.file = event.target.files[0];

    console.log(this.file)
    if (this.file != undefined) {

      this.filesend.push(this.file)
    }
    var events = event.target.files;
    for (let index = 0; index < events.length; index++) {
      const element = events[index];
      this.files.push(element.name)
    }

    console.log(this.filesend)

  }


   deleteAttachment(i) {
    this.files.splice(i, 1)
    this.filesend.splice(i, 1);
  }


  clickDiscard(id) {

    $('#replyPanelall_' + id).hide();
    // let reply_message_{{this.ticket_t}}s
    //  tinymce.activeEditor.setContent('');
    //  tinymce.get('reply_message_'+ id+'s').setContent('');
    tinymce.get('richTextAreaReply').setContent('');
    this.deleteAttachment({});

  }

  get_agents_by_department() {

  }


  UpdateTicketStatus() {
  }

  AddNote() {
  }

  sendFullThread() {
  }

  clearEmailform() {
    this.emailFormControl = new FormControl({ value: '' });
    this.addSenderThread = [];
  }


  toggleClassreplyall(id) {
    console.log(id);
    tinymce.get('richTextAreaReply').setContent('');
    var x = document.getElementById("replyPanelall_" + id);
    $('#replyPanelall_' + id).show();
  }

  backtoPage() {
    this._location.back();
  }

  initTiny() {
    var richTextArea_id = 'richTextAreaReply';
    tinymce.init({
      selector: '#richTextAreaReply',
      height: 500,
      plugins: 'advlist autolink textcolor formatpainter lists link  image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste  wordcount autolink lists media table',
      toolbar: 'undo redo |fullscreen|forecolor backcolor| formatselect | bold italic | \ undo redo | link image file| code | \
       alignleft aligncenter alignright alignjustify | \
       bullist numlist outdent indent | autoresize',
      paste_data_images: true,
      images_upload_url: 'upload.php',
      automatic_uploads: false,
      default_link_target: "_blank",
      extended_valid_elements: "a[href|target=_blank]",
      link_assume_external_targets: true,
      images_upload_handler: function (blobInfo, success, failure) {
        var xhr, formData;

        xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('POST', 'upload.php');

        xhr.onload = function () {
          var json;

          if (xhr.status != 200) {
            failure('HTTP Error: ' + xhr.status);
            return;
          }

          json = JSON.parse(xhr.responseText);

          if (!json || typeof json.file_path != 'string') {
            failure('Invalid JSON: ' + xhr.responseText);
            return;
          }

          success(json.file_path);
        };

        formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());

        xhr.send(formData);
      },
      setup: (editor) => {
        editor.on('keyup change input undo redo', () => {
          this.replyMessageText = editor.getContent();
        });
      },
    });
    if (tinymce.editors.length > 0) {
      //  tinymce.execCommand('mceFocus', true, richTextArea_id );       
      tinymce.execCommand('mceRemoveEditor', true, richTextArea_id);
      tinymce.execCommand('mceAddEditor', true, richTextArea_id);
    }
  }

  onMessageSend($event) {
    if ($event.keyCode != '') {

      // alert('1212')
      this.sendChatMessageData();
      $event.stopPropagation();
      return false;
    }


  }
  getFields(input, field) {
    var output = [];
    for (var i = 0; i < input.length; ++i)
      output.push(input[i][field]);
    return output.toString();
  }


  replyMessage1(msg_id: any,to: any,extra: any) {

    const editor = typeof tinymce !== 'undefined' ? tinymce.get('richTextAreaReply') : null;
    const rawHtml = editor ? editor.getContent() : (this.replyMessageText || '');
    const plainText = rawHtml.replace(/<(?:.|\n)*?>/gm, ' ').replace(/&nbsp;/g, ' ').trim();

    console.log('Reply message (html):', rawHtml);
    console.log('Reply message (plain):', plainText);
    console.log('Ticket ID:', msg_id);
    console.log('To:', to);

    if (!plainText) {
      iziToast.error({
        message: 'Please Enter the Message',
        position: 'topRight'
      });

      return false;
    }

    const message = rawHtml.trim();
    this.replyMessageText = message;

    Swal.fire('Please wait');
    Swal.showLoading();

    const access_token = localStorage.getItem('at');
    const customer_id = localStorage.getItem('en');
    const ticket_to = localStorage.getItem('cms_login_email');

    const datas = {
      action: 'helpdesk_replyticket',
      customer_id: customer_id,
      ticket_id: msg_id,
      comments: message,
      authorEmail: ticket_to
    };

    const datasend = {
      access_token: access_token,
      moduleType: 'ticket',
      operation: 'helpDeskCurl',
      api_type: 'web',
      element_data: datas
    };

    console.log('Reply Request:', datasend);

    this.http.post(
      'https://erp.cal4care.com/cms_new/api_cms/v1.0/index.php',
      datasend
    ).subscribe({

      next: (response: any) => {

        console.log('Reply Response:', response);

        Swal.close();

        if (response?.result?.status === true) {

          iziToast.success({
            message: 'Ticket Replied Successfully',
            position: 'topRight'
          });

          // Clear message
          this.replyMessageText = '';
          if (editor) {
            editor.setContent('');
          }

          // Clear files
          this.files = [];
          this.filesend = [];
          this.file = null;
          this.replaymessage = '';

          // Close reply panel
          $('#replyPanelall_' + msg_id).hide();

          // Reload conversation
          this.thred_view_conversation();

        } else {

          iziToast.error({
            message: response?.result?.message || 'Reply failed',
            position: 'topRight'
          });

        }
      },

      error: (error) => {

        Swal.close();

        console.error('Reply API Error:', error);

        iziToast.error({
          message: 'Unable to send reply',
          position: 'topRight'
        });

      }

    });

    return true;
  }
  replyMessage(msg_id: any, to: any, extra: any) {

    const editor = typeof tinymce !== 'undefined' ? tinymce.get('richTextAreaReply') : null;
    const rawHtml = editor ? editor.getContent() : (this.replyMessageText || '');
    const plainText = rawHtml.replace(/<(?:.|\n)*?>/gm, ' ').replace(/&nbsp;/g, ' ').trim();

    console.log('Reply message (html):', rawHtml);
    console.log('Reply message (plain):', plainText);
    console.log('Ticket ID:', msg_id);
    console.log('To:', to);

    if (!plainText) {
      iziToast.error({
        message: 'Please Enter the Message',
        position: 'topRight'
      });

      return false;
    }

    const message = rawHtml.trim();
    this.replyMessageText = message;

    Swal.fire('Please wait');
    Swal.showLoading();

    const access_token = localStorage.getItem('at') || '';
    const customer_id = localStorage.getItem('en') || '';
    const ticket_to = localStorage.getItem('cms_login_email') || '';

  

    // FormData
    const formData = new FormData();

    formData.append('access_token', access_token || '');
    formData.append('moduleType', 'ticket');
    formData.append('operation', 'helpDeskCurl');
    formData.append('api_type', 'web');

    formData.append('action', 'helpdesk_replyticket');
    formData.append('customer_id', customer_id || '');
    formData.append('ticket_id', String(msg_id));
    formData.append('comments', message);
    formData.append('authorEmail', ticket_to || '');


    // If you have files
    for (var i = 0; i < this.filesend.length; i++) {
      formData.append('attachment[' + i + ']', this.filesend[i]);
    }

    console.log('Reply Request:');

    // Debug FormData
    formData.forEach((value, key) => {
      console.log(key, value);
    });

    this.http.post(
      'https://erp.cal4care.com/cms_new/api_cms/v1.0/index_new.php',
      formData
    ).subscribe({

      next: (response: any) => {

        console.log('Reply Response:', response);

        Swal.close();

        if (response?.result?.status === true) {

          iziToast.success({
            message: 'Ticket Replied Successfully',
            position: 'topRight'
          });

          // Clear message
          this.replyMessageText = '';

          if (editor) {
            editor.setContent('');
          }

          // Clear files
          this.files = [];
          this.filesend = [];
          this.file = null;
          this.replaymessage = '';

          // Close reply panel
          $('#replyPanelall_' + msg_id).hide();

          // Reload conversation
          this.thred_view_conversation();

        } else {

          iziToast.error({
            message: response?.result?.message || 'Reply failed',
            position: 'topRight'
          });

        }
      },

      error: (error) => {

        Swal.close();

        console.error('Reply API Error:', error);

        iziToast.error({
          message: 'Unable to send reply',
          position: 'topRight'
        });

      }

    });

    return true;
  }




  changeMyStatus(ticket_id) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Reopen it!',
      // inputValue: val,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          html:
            '<div style="display: flex;justify-content: center;"><div class="pong-loader"></div></div>',
          showCloseButton: false,
          showCancelButton: false,
          showConfirmButton: false,
          focusConfirm: false,
          background: 'transparent',


        });
        Swal.fire('Please wait');
        Swal.showLoading();
        let api_req: any = '{"operation":"omniCurl","moduleType":"ticket","api_type":"web","access_token":"' + this.acess_token + '","element_data":{"ticket_id":"' + ticket_id + '","ticket_status":"9","action":"cms_reopen_tickets"}}';
        this.serverService.sendServer(api_req).subscribe((response: any) => {
          console.log(response)
          Swal.close();
          if (response.result.status == true) {
            iziToast.success({
              message: "Ticket Reopened Successfully",
              position: 'topRight'
            });
            this.thred_view();
          } else {

          }
        },
          (error) => {
            console.log(error);
          });
      }
    })
  }

  changeMyStatus1() {
    var tickto;
    if (this.ticket_to == this.own_mail) {
      tickto = this.replied_from;
    } else {
      tickto = this.ticket_to;
    }

    let customer_id: any = localStorage.getItem('en');

    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!',
      // inputValue: val,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          html:
            '<div style="display: flex;justify-content: center;"><div class="pong-loader"></div></div>',
          showCloseButton: false,
          showCancelButton: false,
          showConfirmButton: false,
          focusConfirm: false,
          background: 'transparent',


        });
        let api_req: any = new Object;
        let post_req: any = new Object();
        api_req.operation = "ticket";
        api_req.moduleType = "ticket";
        api_req.api_type = "web";
        api_req.access_token = localStorage.getItem('access_token');
        // post_req.admin_id = this.admin_id;
        post_req.user_id = customer_id;
        post_req.action = "oncloseTocket";
        post_req.status_id = "9";
        post_req.alert_status = result.value;
        post_req.ticket_id = this.ticket_t;
        post_req.ticket_to = tickto;
        post_req.ticket_cc = this.ticket_cc;
        api_req.element_data = post_req;


        this.serverService.sendServer(api_req).subscribe((response: any) => {
          Swal.close();
          if (response.status == true) {
            Swal.fire(
              'Closed!',
              'success'
            );
            this.backtoPage();
          }
        },
          (error) => {
            console.log(error);
          });
      }
    })
  }



}